/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { CategoryHierarchy as CategoryHierarchyData } from '@msdyn365-commerce/commerce-entities';
import { IModuleProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

import { IUnbxdSearchResultContainerData } from './unbxd-search-result-container.data';
import { IUnbxdSearchResultContainerProps } from './unbxd-search-result-container.props.autogenerated';

export interface ISearchResultContainerViewProps extends IUnbxdSearchResultContainerProps<IUnbxdSearchResultContainerData> {
    className?: string;
    SearchResultContainer: IModuleProps;
    unbxdSearchJs?: string;
    unbxdSearchCss?: string;
    categoryNames: string[] | null;
}

/**
 *
 * SearchResultContainer component.
 * @extends {React.PureComponent<IUnbxdSearchResultContainerProps<IUnbxdSearchResultContainerData>>}
 */
@observer
export default class SearchResultContainer extends React.PureComponent<IUnbxdSearchResultContainerProps<IUnbxdSearchResultContainerData>> {
    public render(): JSX.Element {
        const { className, unbxdSearchJs, unbxdSearchCss } = this.props.config;

        const searchResultContainerViewProps = {
            ...this.props,
            SearchResultContainer: {
                moduleProps: this.props,
                className: classnames('hei-search-result-container', className)
            },
            unbxdSearchJs,
            unbxdSearchCss,
            categoryNames: this._getCategoryNames()
        };

        return this.props.renderView(searchResultContainerViewProps) as React.ReactElement;
    }

    private readonly _getCategoryNames = (): string[] | null => {
        const { data, context } = this.props;
        const categoryHierarchy = data.categoryHierarchy.result;

        if (context.request.urlTokens.pageType === 'Category' && categoryHierarchy) {
            return categoryHierarchy.map((value: CategoryHierarchyData, index: number) => {
                return value.Name ?? '';
            });
        }

        return null;
    };
}
